const devBaseURL = "https://api.dev.getphyllo.com";
// const devBaseURL = "https://api.dev.getphyllo.comv1";

// const devBaseURL = "https://dashboard-api3.dev.getphyllo.com";
const currentBaseURL = process.env.REACT_APP_API_ENDPOINT;
const phylloSDKBASEURL = process.env.REACT_APP_SDK_API_ENDPOINT;
const profileSDKBASEURL = process.env.REACT_APP_PROFILE_SDK_API_ENDPOINT;
// const phylloSDKBASEURL = "https://api.dev.getphyllo.com";
//const currentBaseURL = devBaseURL;

const webhooksEndpoint = "v1/identity/webhooks";
const signUpEndpoint = "v1/identity/signup";
const signInEndpoint = "v1/identity/login";
const signOutEndpoint = "v1/identity/logout";

const tenantInfoEndpoint = "v1/identity/tenants";
const rotateCredentialsEndpoint = "v1/identity/rotate-credential";
const deleteCredentialsEndpoint = "v1/identity/delete-credential";
const deleteCreatedUserEndpoint = "v1/identity/delete-created-user";
const sendEmailVerificationLinkEndpoint = "v1/identity/send-verification-link";
const forgotPasswordEndpoint = "v1/identity/forgot-password";
const getAllTenantsEndpoint = "v1/identity/tenants";
const setNewPasswordEndpoint = "v1/identity/set-new-password";
const getAllWebhookEventsEndpoint = "v1/identity/webhook-events";
const contactSalesEndpoint = "v1/identity/contact-sales";

const URL_CREATE_USER = "/v1/users";
const URL_CREATE_USER_TOKEN = "/v1/sdk-tokens";
const URL_GET_PROFILE = "/v1/profiles";
const URL_GET_COMMENTS = "social/comments";
const URL_GET_CONTENTS = "social/contents";
const URL_GET_INCOME = "social/income/transactions";

const URL_GET_COMPLIANCE_FORM = "v1/identity/production-access";

const URL_GET_ALL_INVITATIONS = "v1/identity/creator-invites";
const URL_GET_CONNECTED_ACCOUNTS = "v1/identity/creator-invites/connected-accounts";
const URL_GET_FAILED_CONNECTIONS = "v1/identity/creator-invites/failed-connections";
const URL_GET_CONNECTION_ATTEMPTS = "v1/identity/connection-attempts";

const URL_CREATOR_BULK_INVITE = "v1/identity/creator-invites/bulk";
const URL_API_INDIVIDUAL_INVITE = "v1/identity/creator-invites";
const URL_API_RESEND_INVITATION = "v1/identity/creator-invites";
const URL_API_EXPORT_TO_CSV = "v1/identity/creator-invites/profiles/export";

const URL_API_LINK_INFRA_INVITE = `${process.env.REACT_APP_API_ENDPOINT}/v1/identity/link/user-invitations`;
const URL_API_LINK_INFRA_SDK_TOKEN = `${process.env.REACT_APP_API_ENDPOINT}/v1/identity/link/sdk-tokens`;

const URL_GET_ALL_ACCOUNTS_PROFILE = "v1/accounts";
const URL_GET_USER_PROFILE = "v1/profiles";
const URL_GET_AUDIENCE = "v1/audience";
const URL_GET_CONTENT_GROUPS = "v1/social/content-groups";
const URL_GET_CONTENT = "v1/social/contents";

const URL_GET_TENANT_PRODUCTS = "v1/identity/tenant-app-products";

const getDisconnectUrl = (id) => `v1/accounts/${id}/disconnect`;

export {
  devBaseURL,
  currentBaseURL,
  webhooksEndpoint,
  signUpEndpoint,
  signInEndpoint,
  URL_GET_AUDIENCE,
  URL_GET_CONTENT_GROUPS,
  URL_GET_CONTENT,
  tenantInfoEndpoint,
  URL_GET_USER_PROFILE,
  sendEmailVerificationLinkEndpoint,
  forgotPasswordEndpoint,
  getAllTenantsEndpoint,
  URL_GET_ALL_ACCOUNTS_PROFILE,
  rotateCredentialsEndpoint,
  deleteCredentialsEndpoint,
  deleteCreatedUserEndpoint,
  setNewPasswordEndpoint,
  getAllWebhookEventsEndpoint,
  contactSalesEndpoint,
  signOutEndpoint,
  phylloSDKBASEURL,
  profileSDKBASEURL,
  URL_CREATE_USER,
  URL_CREATE_USER_TOKEN,
  URL_GET_PROFILE,
  URL_GET_COMMENTS,
  URL_GET_CONTENTS,
  URL_GET_INCOME,
  URL_GET_COMPLIANCE_FORM,
  URL_GET_ALL_INVITATIONS,
  URL_GET_CONNECTED_ACCOUNTS,
  URL_GET_FAILED_CONNECTIONS,
  URL_API_LINK_INFRA_INVITE,
  URL_API_LINK_INFRA_SDK_TOKEN,
  URL_CREATOR_BULK_INVITE,
  URL_API_INDIVIDUAL_INVITE,
  URL_API_RESEND_INVITATION,
  URL_GET_TENANT_PRODUCTS,
  getDisconnectUrl,
  URL_GET_CONNECTION_ATTEMPTS,
  URL_API_EXPORT_TO_CSV
};
